import type { ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Outlet } from 'react-router';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import {
  ACTIVITY,
  ACTIVITY_NEWS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

export type Tab = {
  value: string;
  label: ReactNode;
  href: string;
};

const Page = styled(Vertical).attrs({ gap: 0 })`
  min-height: var(--100vh);
`;
const Content = styled.div`
  padding: var(--double-unit);
`;

const messages = defineMessages<string>({
  Activity: {
    defaultMessage: 'Activity',
  },
  Notifications: {
    defaultMessage: 'Notifications',
  },
  News: {
    defaultMessage: 'News',
  },
});

const Layout = () => {
  const { currentUser } = useCurrentUserContext();
  const { formatMessage } = useIntl();

  const notificationTab = {
    value: 'notifications',
    label: formatMessage(messages.Notifications),
    href: ACTIVITY,
  };

  const tabs = [
    notificationTab,
    {
      value: 'news',
      label: formatMessage(messages.News),
      href: ACTIVITY_NEWS,
    },
  ].filter(Boolean);

  if (!currentUser) {
    return (
      <AppLayout>
        <Outlet />
      </AppLayout>
    );
  }
  return (
    <AppLayout>
      <PageHeader text={formatMessage(messages.Activity)} />
      <Page>
        <TabBar variant="flat" fullWidth>
          {tabs.map(tab => (
            <Tab key={tab.value} to={tab.href}>
              {tab.label}
            </Tab>
          ))}
        </TabBar>
        <Content>
          <Outlet />
        </Content>
      </Page>
    </AppLayout>
  );
};

export default Layout;
